import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Client, Subscriber } from '../interfaces/person.interface';
import { environment } from '../../environments/environment';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private url = `${environment.api_url}/aforo/app`;

  constructor(
    private accountSrv: AccountService,
    private http: HttpClient,
  ) {}

  createClient(data: any): Observable<Client> {
    let headers = this.accountSrv.headers;
    return this.http.post<Client>(`${this.url}/client/`, data, { headers });
  }

  getClients(search: string): Observable<Client[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<Client[]>(`${this.url}/clients/?search=${search}`, {
      headers,
    });
  }
}
